var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('indica-form',{attrs:{"show-extra-sections":false,"show-many":false,"table-name":_vm.tableName,"label-prefix":_vm.table.labelPrefix},on:{"refresh":_vm.increaseRefresh}}),_c('indica-list',{attrs:{"refresh":_vm.refresh,"table-name":_vm.tableName},on:{"onRowClick":_vm.onRowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }